import React from 'react'
import { AlertTriangle, X } from 'lucide-react'
import { useTheme } from '@/context/ThemeContext'

type Props = {
  percentUsed: number
  remaining: number
  onDismiss: () => void
}

export const UsageWarningBanner: React.FC<Props> = ({ percentUsed, remaining, onDismiss }) => {
  const { currentTheme: t } = useTheme()
  const roundedPercent = Math.round(percentUsed)

  return (
    <div className="px-4 shrink-0" style={{ backgroundColor: t.primary }}>
      <div className="max-w-[60rem] mx-auto">
        <div
          className="mb-2 flex items-start gap-2.5 rounded-2xl px-4 py-3 text-[13px]"
          style={{ backgroundColor: t.inputBackground, border: `1.5px solid ${t.border}`, color: t.text }}
          role="status"
        >
          <AlertTriangle size={16} className="mt-0.5 shrink-0" style={{ color: t.warningText }} />
          <p className="flex-1 leading-snug">
            You've used <strong>{roundedPercent}%</strong> of your monthly AI credits.
            Contact your workspace owner to increase your allocation.
          </p>
          <button
            type="button"
            onClick={onDismiss}
            aria-label="Dismiss"
            className="shrink-0 rounded-full p-1 transition-opacity hover:opacity-70"
            style={{ color: t.mutedText }}
          >
            <X size={14} />
          </button>
        </div>
      </div>
    </div>
  )
}

export default React.memo(UsageWarningBanner)
